'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Api = require('@rushplay/api-client');
var types = require('./types.js');

/**
 * Fetches and stores triggers
 * @memberof rushplay/triggers
 * @returns {Object} Redux Action
 */

function fetch() {
  return Api.fetchAllNotifications({
    success: function success(res) {
      return update(res.value);
    },
    version: 1
  });
}
/**
 * Removes selected notification
 * @memberof rushplay/triggers
 * @param {Number} id
 */

function removeSelected(id) {
  return Api.deleteNotification(id, {
    success: function success() {
      return remove(id);
    },
    version: 1
  });
}
/**
 * Clears triggers state
 * @memberof rushplay/triggers
 * @returns {Object} Redux action
 */

function clear() {
  return {
    type: types.CLEARED
  };
}
/**
 * Stores triggers to state
 * @param {Object} trigger
 * @returns {Object} Redux action
 */

function update(trigger) {
  return {
    type: types.UPDATED,
    payload: trigger
  };
}
/**
 * Removes selected trigger
 * @param {Number} id trigger ID
 * @returns {Object} Redux action
 */

function remove(id) {
  return {
    type: types.REMOVED,
    payload: id
  };
}

exports.clear = clear;
exports.fetch = fetch;
exports.remove = remove;
exports.removeSelected = removeSelected;
exports.update = update;
//# sourceMappingURL=actions.js.map
